// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
// NOTE: when adding new page type constants here, you also *must* add them to
// util/ga.js so that pageviews don't get content group set to 'Not Set'.
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
module.exports = {
  ACCOUNT: 'account',
  ARCHIVE: 'archive',
  AUTHENTICATION: 'authentication',
  AUTHOR: 'author',
  CATEGORY: 'category',
  COLLECTION: 'collection',
  CONTEST: 'contest',
  EMAIL: 'email',
  ERROR_GENERIC: 'error',
  ERROR_NOT_FOUND: 'error404',
  ESSENTIAL_PRODUCTS: 'essentialProducts',
  FAQ: 'faq',
  FEATURE: 'feature',
  HOME: 'home',
  HOMEMADE: 'homemade',
  IMAGE_COLLECTION: 'imageCollection',
  K_FOOD_FEST: 'kitchnFoodFest2020',
  PAGE: 'page',
  POST: 'post',
  PREVIEW: 'preview',
  PRISM_COLOR: 'prismColor',
  PRISM_IMAGE: 'prismImage',
  PRISM_TAG: 'prismTag',
  RECIPE_BOX: 'recipeBox',
  SAVED_STORIES: 'savedStories',
  SEARCH: 'search',
  SITEMAP: 'sitemap',
  SMALL_COOL_EXPERIENCE: 'smallCoolExperience',
  STATIC_PRISM_PAGE: 'staticPrismPage',
  SUBMISSION: 'submission',
  TEAM: 'team',
  VISION_BOARD: 'visionBoard',
  VISION_BOARDS: 'visionBoards',
  WISH_LIST: 'wishList',
  WISH_LISTS: 'wishLists'
};
